<div
  #dialog
  aria-describedby="modal-popup-modal-content"
  aria-labelledby="modalTitle"
  class="modal-popup container content mt-0 border-top-0"
  role="dialog"
  tabindex="0"
>
  <div class="modal-popup-flyout">
    <div class="mt-0 border-0">
      <div class="modal-header">
        <h4 [innerHTML]="axPopupContent?.modelTitle" class="title"></h4>
        <!-- <span class="sr-only" id="modalTitle">{{axPopupContent?.modelTitle}}</span> -->
        <button
          (click)="close()"
          class="modal-popup-close-icon float-right circle-outline icon-moreoptionsclose"
          role="button"
        >
          <span class="sr-only">Close</span>
        </button>
      </div>
      <div class="modal-popup-flyout-modal-content">
        <div class="modal-body pl-0">
          <div [innerHTML]="axPopupContent?.modelDescription"></div>
        </div>
        <div
          class="modal-footer justify-content-lg-end justify-content-md-center pl-0 border-0"
        >
          <button
            (click)="submit()"
            class="btn-modal-action btn btn-danger rounded-0"
          >
            {{axPopupContent?.firstButtonText}}
          </button>
          <a
            (click)="close()"
            class="btn-keep btn btn-outline-secondary-cta rounded-0"
            href="javascript:void(0);"
          >
            {{axPopupContent?.secondButtonText}}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
